import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import DevelopmentSpacesView from "@/views/DevelopmentSpacesView.vue";
import ExampleDevView from "@/views/development/example/ExampleDevView.vue";
import { devRoutes } from "./dev-routes";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/spaces-development",
    name: "Simulate DP Spaces Header",
    component: DevelopmentSpacesView,
  },
  ...devRoutes,
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
